import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Stack } from "@carbon/react";
import { CardComponent } from "../../../components/Layouts/Card.styles";
import { HeatMap_02 as HeatMap, ListChecked } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import Card from '../../../components/Layouts/Card';
import { Iframe } from "./TruckApproach.styles";
import InformationContainer from "../../../components/Basics/Information.container";
import SearchTable from '../../../components/Basics/SearchTable.container';
import LoadingContent from "../../../components/Animations/LoadingContent";
import { spacing05 } from "@carbon/themes";
import { onGetStateFatigueThunk } from './Truckaproach.actions';

const TruckApproachContainer = () => {
    const dispatch = useDispatch();
    const { loading_state, lista } = useSelector(state => state.Fatigue);

    const [searchTableRows, setSearchTableRows] = useState([]);

    const searchTableHeaders = [
        { key: 'patent', header: 'Patente' },
        { key: 'deviceId', header: 'Device ID' },
        { key: 'type', header: 'Tipo' },
        { key: 'name', header: 'Nombre' },
        { key: 'surname', header: 'Apellido' },
        { key: 'geofenceName', header: 'Geocerca' },
        { key: 'etiqueta', header: 'Tipo de alerta' },
        { key: 'time', header: 'Fecha/Hora' },
        { key: 'vo', header: 'Odómetro (m)' },
        { key: 'ultimoOdometro', header: 'Último Odómetro (m)' },
        { key: 'diferenciaVo', header: 'Diferencia Odómetro (m)' },
    ];

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return 'N/A';
        const date = new Date(timestamp);
        return date.toLocaleString('es-CL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    useEffect(() => {
        dispatch(onGetStateFatigueThunk());
    }, [dispatch]);

    useEffect(() => {
        if (lista && lista.length > 0) {
            const transformedRows = lista.map((item, index) => ({
                id: item.id || `row-${index + 1}`,
                patent: item.patent || 'N/A',
                deviceId: item.device_id || 'N/A',
                type: item.type || 'N/A',
                name: item.name || 'Sin Registro',
                surname: item.surname || 'Sin Registro',
                geofenceName: item.geofence_name || 'Sin Registro',
                etiqueta: item.Etiqueta || 'N/A',
                time: formatTimestamp(item.time),
                vo: item.vo || 'N/A',
                ultimoOdometro: item.ultimo_odometro !== null ? item.ultimo_odometro : 'N/A',
                diferenciaVo: item.diferencia_vo !== null ? item.diferencia_vo : 'N/A',
            }));
            setSearchTableRows(transformedRows);
        }
    }, [lista]);

    return (
        <>
            {loading_state ? (
                <LoadingContent />
            ) : (
                <Stack gap={3}>
                    <CardComponent width="100%">
                        <Card justifyContent='flex-start'>
                            <HeatMap size={18} />
                            <Typography className='cds--type-heading-compact-01'>
                                REGISTRO DE ACERCAMIENTOS ENTRE CAMIONES - MAPA DE CALOR
                            </Typography>
                        </Card>
                        <Card>
                            <Iframe
                                title="Monitoring map"
                                src="https://grafana.terrestra.tech/d/e0d192ef-4776-438f-8462-d9c48e3ea048/adas?orgId=1&var-patente=All&var-intervalo=1h&var-advertencia=All&var-geocerca=All&refresh=1m&from=1712728977303&to=1712750577303&kiosk"
                                width="100%"
                                height="100%"
                            />
                        </Card>
                    </CardComponent>

                    <Card justifyContent='flex-start'>
                        <ListChecked size={18} />
                        <Typography className='cds--type-heading-compact-01'>
                            ÚLTIMO DATO DE ADAS DE CADA EQUIPO - TABLA DE DATOS
                        </Typography>
                    </Card>
                    <InformationContainer description="La tabla muestra el último dato ADAS de cada equipo que se haya recibido datos." />
                    <Card justifyContent='flex-start' padding={spacing05} flexDirection="column" style={{ width: '100%' }}>
                        <SearchTable
                            title="Datos Históricos ADAS"
                            rows={searchTableRows}
                            headers={searchTableHeaders}
                            downloadFileName="ultimo_dato_adas.csv"
                        />
                    </Card>
                </Stack>
            )}
        </>
    );
};

export default TruckApproachContainer;